export class CollaborationResult {
    constructor(collaborationName, message, data) {
        this.data = data;
        this.message = `[${collaborationName}] - ${message}`;
        this.identifier = collaborationName;
    }
}
